// extracted by mini-css-extract-plugin
export var wrapper = "index-module--wrapper--AV3Gy";
export var image = "index-module--image--2XYwS";